import React from 'react'
import {connect} from 'react-redux';
import {Flex} from '/app/src/component'
import {SystemSelector}from '/app/src/model/selectors'
import { Route, Switch } from 'react-router'
import HistoryRightPanel from './History'
import ConversationRightPanel from './Conversation'
import SearchCustomerRightPanel from './Search/Customer'
import SearchTicketRightPanel from './Search/Ticket'
import MainMenuRightPanel from './MainMenu'
import AutoMessageMenuPreview from './AutoMessageMenuPreview'
import ClientChatMenu from './ClientChatMenu'

class RightPanel extends React.Component {

    render(){
        if(this.props.menuToogle){
            return <Flex  basis='25%' borderLeft='1px solid' color='lightgrey'>
                        <MainMenuRightPanel/>
                    </Flex>
        }
        if(!this.props.param.length){
            return null;
        }

        //Removes rightpanel if the route is tutorial
        if(this.props.param[0] === 'tutorial'){
            return null;
        }

        return (
            <Flex  w='25%' borderLeft='1px solid' color='lightgrey' dataName='RightPanelLayout' shrink={0}>
                    <Switch>
                        {this.props.menuToogle && <Route key='main' component={MainMenuRightPanel}/>}
                        <Route key='history' path='/history' component={HistoryRightPanel}/>
                        <Route key='conversation' path='/conversation' component={ConversationRightPanel}/>
                        <Route key='searchcustomer' path='/searchCustomer' component={SearchCustomerRightPanel}/>
                        <Route key='searchticket' path='/searchTicket' component={SearchTicketRightPanel}/>
                        <Route path='/clientChat/autoMessage/preview/:id' component={AutoMessageMenuPreview}/>
                        <Route path='/clientChat/faq/helpdesk/' component={ClientChatMenu}/>
                        <Route path='/' component={MainMenuRightPanel}/>
                    </Switch>
            </Flex>
            )
    }
}

function mapStateToProps(state, ownProps){
    return {
        menuToogle: state.getIn(['system', 'menu', 'toogle']),
        param: SystemSelector.getParams(state),
    }
}

export default connect(mapStateToProps)(RightPanel);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/index.js